import { isEmpty } from '../helpers/isEmpty';

const Input = (props) => {
  const {
    labelText,
    value,
    onChange,
    name,
    StartIcon,
    EndIcon,
    prefixText = '',
    mainTagClassname,
    type,
    placeholder,
    maxLength,
    isError,
    inputClassName = '',
    labelSubText,
    onSubLabelClick,
    labelClassName,
    placeholderColor,
    ...rest
  } = props;

  return (
    <div className={mainTagClassname}>
      <div className='flex justify-between'>
        {isEmpty(labelText) !== '' && (
          <label
            className={`${
              labelClassName ? labelClassName : ''
            } text-sm md:text-[16px] text-[14px] font-semibold text-gray-2 flex-col flex mb-2`}
          >
            {labelText}
          </label>
        )}
        {isEmpty(labelSubText) !== '' && (
          <label
            className='text-sm md:text-[16px] text-[14px] font-semibold text-primary cursor-pointer flex-col flex mb-2'
            onClick={onSubLabelClick}
          >
            {labelSubText}
          </label>
        )}
      </div>

      <div className='relative flex items-center'>
        {StartIcon && (
          <span className='absolute left-3 cursor-pointer'>{StartIcon}</span>
        )}
        <input
          maxLength={maxLength}
          placeholder={placeholder}
          type={type ? type : 'text'}
          className={
            'font-semibold text-[16px]' +
            ' ' +
            inputClassName +
            ' ' +
            `border ${
              isError
                ? 'border-red  focus:border-red '
                : 'border-gray-1  focus:border-primary '
            } ${EndIcon ? 'pr-10' : ''}
          w-full h-[46px] sm:h-12 md:h-[50px] xl:h-[52px] text-sm focus:bg-white active:bg-white py-[13px] px-[20px] focus:outline-none rounded-[100px] placeholder:font-semibold placeholder:text-[16px] font-semibold ` +
            ` ${placeholderColor}` // Apply custom placeholder color
          }
          value={value}
          name={name ? name : ''}
          onChange={(e) => onChange(e)}
          {...rest}
        />
        {prefixText && (
          <span
            className={`bg-white pl-1 absolute text-gray ${
              EndIcon ? 'right-8' : 'right-3'
            }  cursor-pointer`}
          >
            {prefixText}
          </span>
        )}
        {EndIcon && (
          <span className='absolute right-3 cursor-pointer'>{EndIcon}</span>
        )}
      </div>
    </div>
  );
};

export default Input;
